module.exports = __webpack_public_path__ + "img/public/SiteIcons/importIcon.svg?6d5a8be1";